import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import {
  ColorMode,
  FiltersState,
  FiltersStateModel,
  SetFilters,
  SetFiltersFromUrlQueryParams,
  SetUrlQueryParamsFromState
} from '@lla-platform/core/core-data-access'
import { Store } from '@ngxs/store'
import { isEmpty, isObject } from 'lodash'
import { filter, map, Subscription } from 'rxjs'
import { gtag } from 'ga-gtag'
import { IUser, UserAccountState } from '@lla-platform/users/users-data-access'
import packageJson from '../../../../package.json'
import { LOCAL_STORAGE_KEYS } from '@lla-platform/core/core-util'

@Component({
  selector: 'lla-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private colorModeSub?: Subscription

  constructor(
    private router: Router,
    private store: Store
  ) {}

  ngOnInit(): void {
    console.info(`Jarvis Version: ${packageJson.version}`)

    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        map(() => {
          return this.router.routerState.root.snapshot.queryParams
        })
      )
      .subscribe((params) => {
        const currentUser = this.store.selectSnapshot<IUser>(UserAccountState.currentUser)
        gtag('set', 'user_properties', { email: currentUser?.email ?? 'Not Login' })
        gtag('event', 'page_view', {
          page_title: window.document.title,
          page_location: window.location.href,
          email: currentUser?.email ?? 'Not Login'
        })
        if (!isEmpty(params) && params['filters']) {
          this.store.dispatch(new SetFiltersFromUrlQueryParams(params['filters']))
        } else {
          this.store.dispatch(new SetUrlQueryParamsFromState())
        }
      })

    this.colorModeSub = this.store.select(FiltersState.colorMode).subscribe((mode) => {
      const persistObj = localStorage.getItem(LOCAL_STORAGE_KEYS.FILTERS)
      const filters: Partial<FiltersStateModel> = persistObj ? JSON.parse(persistObj) : {}
      const saveColorMode = isObject(filters) && !isEmpty(filters) ? filters.colorMode : undefined
      this.applyColorMode(mode || saveColorMode)
    })
  }

  ngOnDestroy(): void {
    this.colorModeSub?.unsubscribe()
  }

  private applyColorMode(mode: ColorMode | undefined): void {
    if (mode === ColorMode.Dark) {
      document.documentElement.classList.add('dark')
    } else if (mode === ColorMode.Light) {
      document.documentElement.classList.remove('dark')
    } else {
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      this.store.dispatch(
        new SetFilters({ colorMode: systemPrefersDark ? ColorMode.Dark : ColorMode.Light })
      )
    }
  }
}
